import { memo } from 'react'
import { Provider } from 'react-redux'
import { store } from 'redux-store/store'

interface ReduxProviderProps {}
export const ReduxProvider: React.FC<React.PropsWithChildren<ReduxProviderProps>> = memo(({ children }) => {
    return <Provider store={store}>{children}</Provider>
})
ReduxProvider.displayName = 'ReduxProvider'
